import $ from "jquery";
import * as bootbox from "bootbox";
import moment from "moment";
import "bootstrap-colorpicker";
import "eonasdan-bootstrap-datetimepicker";
import autosize from "autosize";
import Seed from "DMS/Seed/All";
import { encodeParam } from "DMS/Utils/parameter";
import { resizeScreen } from "DMS/Utils/resizeScreen";
import { processPHP } from "DMS/Utils/processLauncher";
import * as smartController from "DMS/Controllers/smartController";
import AngularController from "DMS/Controllers/angularController";
import { AppModule } from "DMS/Interfaces/app.module";
import { LexiqueService } from "DMS/Interfaces/lexique.service";
import { DataService } from "DMS/Interfaces/data.service";
// Smartphone
export function editPanel(panelId) {
    var currentPanel = Seed.Tab.GetFrame().find('#toShow' + panelId);
    Seed.Tab.SetElementChildNumber(currentPanel[0], false, false, true);
    smartController.editPanel(panelId);
}
export function callFormAngular(nomliste, numaction, bbmindex, pImport) {
    Seed.Ajax.Get({
        url: root + "../../EManage/api/interfaces/" + nomliste,
        /*data: "valeurCle=" + bbmindex
            + "&numcontent=" + numcontent
            + "&numaction=" + numaction
            + sImport
            + "&moduleType=" + moduleType,*/
        async: true,
    }).then((html) => {
        Seed.Tab.AddTab();
        let numcontent = Seed.Tab.cTab.attr('id');
        let numcontentform = 0;
        numcontentform = eval(numcontent) + 1; // @todo : WTF ?
        let pTargetId = "tab_" + numcontent;
        Seed.Tab.SetCallback(() => {
            let sImport = "";
            if (pImport) {
                let pImportLength = pImport.length;
                for (var i = 0; i < pImportLength; i++) {
                    sImport += "&" + pImport[i][0] + "=" + encodeParam(pImport[i][1]);
                }
            }
            AngularController.bootstrapIfNeeded(AppModule).then(() => {
                document.getElementById(pTargetId).innerHTML = html;
                let tabname = document.getElementById(pTargetId).firstChild.getAttribute("dms-tabname");
                let promiseData = AngularController.injector.get(DataService).execute(bbmindex, nomliste);
                AngularController.injector.get(LexiqueService).requestTranslation(tabname).subscribe((tab_lexique) => {
                    Seed.Tab.SetText(tab_lexique);
                });
                let promiseLexique = AngularController.injector.get(LexiqueService).execute(culture, nomliste);
                Promise.all([promiseLexique, promiseData]).then(resizeScreen);
            });
        });
        Seed.Tab.GetCallback();
    }).catch(err => bootbox.alert(err.toString()));
}
// Edition2
export function callForm(numAction, bbmindex, sImport) {
    Seed.Tab.AddTab();
    let numcontent = Seed.Tab.cTab.attr('id');
    let pTargetId = "tab_" + numcontent;
    Seed.Tab.SetCallback(function callb() {
        Seed.Form.requestFormulaire(numcontent, pTargetId, numAction, bbmindex, sImport);
    });
    Seed.Tab.GetCallback();
}
// setTabText : mettre à jour le texte de l'onglet courant ? false si le formulaire est dans une popup
export function initializeForm(fieldName, libelle, bbmindex, dateValues, pTargetId = null, setTabText = true, liste) {
    multiScript(fieldName, libelle, bbmindex, pTargetId, setTabText, liste);
    setDate(dateValues);
    multiScript2(pTargetId);
    Seed.Tab.GoToPosition();
}
/**
 * @param {string} fieldName
 * @param {string} libelle
 * @param {int} bbmindex
 * @param {string} pTargetId identifiant du dom element (onglet ou popup)
 * @param {boolean} setTabText mettre à jour le texte de l'onglet courant ? false si le formulaire est dans une popup
 * @param {string} liste Name of the list the form is related to - only use for signature
 */
export function multiScript(fieldName, libelle, bbmindex, pTargetId = null, setTabText = true, liste) {
    // onglet ou popup
    let pTargetJqueryObj = $('#' + pTargetId);
    if (setTabText) {
        if (fieldName) {
            let elementJqueryObj = pTargetJqueryObj.find("#" + fieldName);
            if (elementJqueryObj.length !== 0) {
                libelle = encodeParam(libelle + ':' + elementJqueryObj.val());
            }
        }
        Seed.Tab.SetText(libelle);
    }
    pTargetJqueryObj.find('.SM-datepicker')
        .parent()
        .find('button')
        .click(function (event) {
        $(this).parent().parent()
            .find('input')
            .data('DateTimePicker').show();
    });
    pTargetJqueryObj.find('.SM-datetimepicker')
        .parent()
        .find('button')
        .click(function (event) {
        $(this).parent().parent()
            .find('input')
            .data('DateTimePicker').show();
    });
    pTargetJqueryObj.find('.SM-timepicker').parent()
        .find('button')
        .click(function (event) {
        $(this).parent().parent()
            .find('input')
            .data('DateTimePicker').show();
    });
    // Date
    pTargetJqueryObj.find(".SM-datepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        showTodayButton: true,
        showClear: true,
        format: "L",
        useCurrent: false
    });
    // DateHeure
    pTargetJqueryObj.find(".SM-datetimepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        showTodayButton: true,
        showClear: true,
        format: "L LT",
        useCurrent: false
    });
    // Heure
    pTargetJqueryObj.find(".SM-timepicker:not(.duration)").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        format: "LT",
        useCurrent: false
    });
    // duration = same as type 'heure' but with an initialization to 00:00
    pTargetJqueryObj.find(".duration.SM-timepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        format: "LT",
        useCurrent: false,
        defaultDate: moment().hours(0).minutes(0).seconds(0).milliseconds(0)
    });
    // colorpicker
    pTargetJqueryObj.find('.color').colorpicker({ format: 'hex' })
        .on('hidePicker', function (e) {
        var tmp = $(this).children()[0];
        $(tmp).trigger('change');
    });
    // autosize
    let autosizes = pTargetJqueryObj.find('textarea.textarea');
    autosizes.css('transition', 'height 0.2s ease 0s');
    autosizes.css('height', '50px');
    autosizes.css('min-height', '50px');
    autosizes.css('max-height', '180px');
    autosizes.css('resize', 'none');
    autosize(autosizes);
    //Bind des tooltips eventuelles
    pTargetJqueryObj.find('.bt_tooltip').tooltip({ container: 'body' });
    // Barre de boutons vide
    pTargetJqueryObj.find('.buttonBar:empty').hide();
    // scrollspy & affix
    $('[data-spy=\"scroll\"]').each(function () {
        var spy = $(this).scrollspy('refresh');
    });
    // Modal et signature
    $("#modalIframeContent").off("hidden.bs.modal");
    $("#modalIframeContent").on("hidden.bs.modal", () => signaturePadClass.signCheck(bbmindex, liste));
    Seed.Tab.SetVisibility(pTargetJqueryObj);
}
export function setDate(values) {
    if (values !== null && typeof values === 'object') {
        for (var i = 0; i < values.length; i++) {
            for (var key in values[i]) {
                var value = values[i][key];
                var data = $("#" + key).data("DateTimePicker");
                if (typeof data !== "undefined") {
                    data.date(moment(value));
                }
            }
        }
    }
}
export function multiScript2(pTargetId = null) {
    let pTargetJqueryObj = {};
    if (pTargetId === null) {
        pTargetJqueryObj = Seed.Tab.GetFrame();
    }
    else {
        pTargetJqueryObj = $('#' + pTargetId);
    }
    pTargetJqueryObj.find(".SM-timepicker").on("dp.show", function (e) {
        pTargetJqueryObj.withKeyboard = false;
        pTargetJqueryObj.originalDate = e.currentTarget.value;
        pTargetJqueryObj.onchangeDate = $(this)[0].attributes["data-onchange"].value;
    });
    pTargetJqueryObj.on('keypress', 'input.SM-timepicker', function (e) {
        pTargetJqueryObj.withKeyboard = true;
    });
    pTargetJqueryObj.find(".SM-timepicker").on("dp.change", function (e) {
        if (pTargetJqueryObj.originalDate !== e.currentTarget.value && pTargetJqueryObj.originalDate !== undefined && pTargetJqueryObj.withKeyboard) {
            pTargetJqueryObj.withKeyboard = false;
            eval(pTargetJqueryObj.onchangeDate);
            pTargetJqueryObj.onchangeDate = undefined;
        }
    });
    pTargetJqueryObj.find(".SM-timepicker").on("dp.hide", function (e) {
        if (!pTargetJqueryObj.withKeyboard) {
            eval(pTargetJqueryObj.onchangeDate);
            pTargetJqueryObj.onchangeDate = undefined;
        }
    });
    pTargetJqueryObj.find(".SM-datepicker").on("dp.show", function (e) {
        pTargetJqueryObj.withKeyboard = false;
        pTargetJqueryObj.originalDate = e.currentTarget.value;
        pTargetJqueryObj.onchangeDate = $(this)[0].attributes["data-onchange"].value;
    });
    pTargetJqueryObj.on('keypress', 'input.SM-datepicker', function (e) {
        pTargetJqueryObj.withKeyboard = true;
    });
    pTargetJqueryObj.find(".SM-datepicker").on("dp.change", function (e) {
        if (pTargetJqueryObj.originalDate !== e.currentTarget.value && pTargetJqueryObj.originalDate !== undefined && pTargetJqueryObj.withKeyboard) {
            pTargetJqueryObj.withKeyboard = false;
            eval(pTargetJqueryObj.onchangeDate);
            pTargetJqueryObj.onchangeDate = undefined;
        }
    });
    pTargetJqueryObj.find(".SM-datepicker").on("dp.hide", function (e) {
        if (!pTargetJqueryObj.withKeyboard) {
            eval(pTargetJqueryObj.onchangeDate);
            pTargetJqueryObj.onchangeDate = undefined;
        }
    });
    pTargetJqueryObj.find(".SM-datetimepicker").on("dp.show", function (e) {
        pTargetJqueryObj.withKeyboard = false;
        pTargetJqueryObj.originalDate = e.currentTarget.value;
        pTargetJqueryObj.onchangeDate = $(this)[0].attributes["data-onchange"].value;
    });
    pTargetJqueryObj.on('keypress', 'input.SM-datetimepicker', function (e) {
        pTargetJqueryObj.withKeyboard = true;
    });
    pTargetJqueryObj.find(".SM-datetimepicker").on("dp.change", function (e) {
        if (pTargetJqueryObj.originalDate !== e.currentTarget.value && pTargetJqueryObj.originalDate !== undefined && pTargetJqueryObj.withKeyboard) {
            pTargetJqueryObj.withKeyboard = false;
            eval(pTargetJqueryObj.onchangeDate);
            pTargetJqueryObj.onchangeDate = undefined;
        }
    });
    pTargetJqueryObj.find(".SM-datetimepicker").on("dp.hide", function (e) {
        if (!pTargetJqueryObj.withKeyboard) {
            eval(pTargetJqueryObj.onchangeDate);
            pTargetJqueryObj.onchangeDate = undefined;
        }
    });
}
/**
 * Déplacment vers un élément de la page
 * @param {type} dataArray tablean contenant l'id Sidebar et l'ance associé
 */
export function smoothScrolling(dataArray) {
    //    var idSideBar = dataArray[0];
    var idAnchor = dataArray[1];
    $('html, body')
        // on arrête toutes les animations en cours
        .stop()
        /* on fait maintenant l'animation vers le haut (scrollTop) vers
         notre ancre Id */
        .animate({
        scrollTop: $('#' + idAnchor).offset().top - Seed.Tab.GetFrame()
            .find('.edition2').offset().top
    }, 1500);
}
export function formSendMail(message, param) {
    bootbox.confirm(message, function (result) {
        if (result === true) {
            processPHP('php_spec/envoimail.php?'
                + 'nometat=' + Seed.Tab.GetFrame()
                .find('#listeedition').val(), param);
        }
    });
}
//# sourceMappingURL=formController.js.map